module.exports = __webpack_public_path__ + "img/11.05116ad6.png";